import TarifaService from "@/api/services/cobranza/nomencladores/TarifaService"
import CicloService from "@/api/services/cobranza/nomencladores/CicloService"
import Vue from "vue"

const state = () => ({
    tarifas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    TARIFAS: state => {
        return state.tarifas
    },
    TARIFAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_TARIFAS: (state, payload) => {
        state.tarifas = payload
    },

    SET_TARIFAS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_TARIFA: (state, payload) => {
        state.tarifas.push(payload)
    },

    UPDATE_TARIFA: (state, payload) => {
        state.tarifas = state.tarifas.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_TARIFA: (state, payload) => {
        state.tarifas = state.tarifas.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_TARIFAS: async ({ commit, state }, { cicloID, filter, tarifaEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TarifaService.get({ cicloID, filter, tarifaEstado, ...pagination })
            if (status === 200) {
                commit("SET_TARIFAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las tarifas, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_TARIFAS: async ({ commit }) => {
        try {
            let { data, status } = await TarifaService.getAll()
            if (status === 200) {
                commit("SET_TARIFAS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_CICLO_DETAILS_TARIFAS: async ({ commit }, payload) => {
        try {
            let { data, status } = await CicloService.getCicloDetails(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los datos del campus proveniente, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_RECORDS_TARIFAS: async ({ commit }) => {
        try {
            let { data, status } = await TarifaService.getAllRecords()
            if (status === 200) {
                commit("SET_TARIFAS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las tarifas, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_TARIFA: async ({ commit }, payload) => {
        try {
            let { data, status } = await TarifaService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_TARIFA", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial de la tarifa, inténtelo nuevamente"
            })
        }
    },

    ADD_TARIFA: async ({ commit }, payload) => {
        try {
            let { data, status } = await TarifaService.post(payload)
            if (status === 201) {
                commit("ADD_TARIFA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "La tarifa ha sido agregada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar la tarifa, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_TARIFA: async ({ commit }, payload) => {
        try {
            let { data, status } = await TarifaService.put(payload)
            if (status === 200) {
                commit("UPDATE_TARIFA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La tarifa ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la tarifa, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_TARIFA: async ({ commit }, payload) => {
        try {
            let { status, data } = await TarifaService.delete(payload)
            if (status === 204) {
                commit("DELETE_TARIFA", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "La tarifa ha sido eliminada satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_TARIFA", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "La tarifa ha sido deshabilitada satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar la tarifa, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
